export default "__VITE_ASSET__D9br1Pdm__"